import { render, staticRenderFns } from "./MunicipalitySelectionShowButton.vue?vue&type=template&id=21af3520&scoped=true&"
import script from "./MunicipalitySelectionShowButton.vue?vue&type=script&lang=ts&"
export * from "./MunicipalitySelectionShowButton.vue?vue&type=script&lang=ts&"
import style0 from "./MunicipalitySelectionShowButton.vue?vue&type=style&index=0&id=21af3520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af3520",
  null
  
)

export default component.exports